<button
    [style.--grad1]="g1"
    [style.--grad2]="g2"
    [style.--grad3]="g3"
    [ngClass]="{
        'gradient-1': !!g1 && !g2 && !g3,
        'gradient-2': !!g1 && !!g2 && !g3,
        'gradient-3': !!g1 && !!g2 && !!g3
    }"
><ng-content></ng-content></button>
